import * as types from '../types';
import { call, put, takeEvery } from 'redux-saga/effects';
import { getScormProgress } from '../api/scorm';
import { scormActions } from '../actions';

function* getScormProgressRequest(action) {
    try {
        const { registrationId, repoId } = action.payload;
        const res = yield call(getScormProgress, registrationId, repoId);
        yield put(scormActions.getScormProgressSuccess(res.data));
    } catch (error) {
        yield put(scormActions.getScormProgressFail(error));
    }
}

function* scormWatcher() {
    yield takeEvery(types.GET_SCORM_PROGRESS_REQUEST, getScormProgressRequest);
}

export { scormWatcher };
